<div class="image circle">
  <div *ngIf="uploadLoader" class="spinner-grow text-primary spinner-border-sm"></div>
  <img *ngIf="!src" src="assets/images/icons/corporate-user-icon.svg" alt="">
  <img *ngIf="src" [src]="src" alt="">
  <input #inputField type="file" id="imageUpload-{{index}}"
    accept="image/jpeg, image/pjpeg, image/png"
    (change)="fileSelected($event)" (click)="inputField.value = ''" />
</div>
